import { apiRequest } from './apiClient';

export const ISLEM_TIPLERI = ['Kurulum', 'Bakım', 'Arıza', 'Sipariş'];

export function isSiparisOnlySablon(sablon) {
  return sablon?.islemTipi === 'Sipariş';
}

export function fetchTestSablonlar() {
  return apiRequest('/api/test-sablonlar', { method: 'GET' });
}

export function fetchTestSablon(id) {
  return apiRequest(`/api/test-sablonlar/${encodeURIComponent(id)}`, { method: 'GET' });
}

export function createTestSablon(body) {
  return apiRequest('/api/test-sablonlar', { method: 'POST', body });
}

export function updateTestSablon(id, body) {
  return apiRequest(`/api/test-sablonlar/${encodeURIComponent(id)}`, {
    method: 'PUT',
    body,
  });
}

export function deleteTestSablon(id) {
  return apiRequest(`/api/test-sablonlar/${encodeURIComponent(id)}`, { method: 'DELETE' });
}

export function seedVarsayilanArizaSablon() {
  return apiRequest('/api/test-sablonlar/varsayilan-ariza', { method: 'POST', body: {} });
}

export function runTestSablon(id) {
  return apiRequest(`/api/test-sablonlar/${encodeURIComponent(id)}/run`, {
    method: 'POST',
    body: {},
  });
}

export function fetchTestSablonAktorler() {
  return apiRequest('/api/test-sablonlar/yardim/aktorler', { method: 'GET' });
}

export function fetchTestSablonParcalar(params = {}) {
  const q = new URLSearchParams();
  if (params.arama) q.set('arama', params.arama);
  if (params.sayfa) q.set('sayfa', String(params.sayfa));
  if (params.limit) q.set('limit', String(params.limit));
  const qs = q.toString();
  return apiRequest(`/api/test-sablonlar/yardim/parcalar${qs ? `?${qs}` : ''}`, { method: 'GET' });
}

export function fetchTestSablonIslemler(params = {}) {
  const q = new URLSearchParams();
  if (params.arama) q.set('arama', params.arama);
  if (params.sayfa) q.set('sayfa', String(params.sayfa));
  if (params.limit) q.set('limit', String(params.limit));
  const qs = q.toString();
  return apiRequest(`/api/test-sablonlar/yardim/islemler${qs ? `?${qs}` : ''}`, { method: 'GET' });
}

export function fetchTestSablonUrunler(params = {}) {
  const q = new URLSearchParams();
  if (params.limit) q.set('limit', String(params.limit));
  const qs = q.toString();
  return apiRequest(`/api/test-sablonlar/yardim/urunler${qs ? `?${qs}` : ''}`, { method: 'GET' });
}

export function fetchTestSablonArizalar(params = {}) {
  const q = new URLSearchParams();
  if (params.limit) q.set('limit', String(params.limit));
  const qs = q.toString();
  return apiRequest(`/api/test-sablonlar/yardim/arizalar${qs ? `?${qs}` : ''}`, { method: 'GET' });
}

export function fetchTestSablonCihazlar(adi, soyadi) {
  const q = new URLSearchParams({ adi, soyadi });
  return apiRequest(`/api/test-sablonlar/yardim/cihazlar?${q}`, { method: 'GET' });
}

export function fetchTestSablonChecklist(icerikId) {
  return apiRequest(
    `/api/test-sablonlar/yardim/checklist?icerikId=${encodeURIComponent(icerikId)}`,
    { method: 'GET' },
  );
}

export function emptyRandevuAdim(islemTipi, garantiDahilinde = true) {
  const adim = {
    tip: 'randevu',
    gunOffset: 1,
    saat: '09:00',
    katalogIslemler: [],
    ilaveIslemler: [],
    parcaKullanimlari: [],
    otp: {
      garantiDahilinde: islemTipi === 'Kurulum' ? true : !!garantiDahilinde,
      yeniRandevuGerekli: false,
      siparisGerekli: false,
      ilkCalistirmaYapildi: islemTipi === 'Kurulum' ? true : undefined,
    },
  };
  if (islemTipi === 'Kurulum') {
    adim.kurulumOtp = { seriNoKaynak: 'sablon' };
  }
  return adim;
}

export function emptySiparisAdim(opts = true) {
  const legacyGaranti = typeof opts === 'boolean' ? opts : undefined;
  const {
    garantiDahilinde = legacyGaranti ?? true,
    konsinye = false,
    standalone = false,
  } = typeof opts === 'object' && opts !== null ? opts : { garantiDahilinde: legacyGaranti ?? true };

  const adim = {
    tip: 'siparis',
    satirlar: [{ parcaMod: 'random', icerikId: null, siparisAdet: 1, kullanilacakAdet: 1 }],
    admin: { kargoFirmasi: 'Test Kargo', kargoTakipNo: '', faturaBilgisi: '' },
    garantiDahilinde: standalone ? false : garantiDahilinde,
    konsinye: standalone ? konsinye : false,
  };
  return adim;
}

export function applySablonGarantiToAdimlar(adimlar, garantiDahilinde, islemTipi) {
  if (!Array.isArray(adimlar)) return adimlar;
  const garanti = !!garantiDahilinde;
  return adimlar.map((adim) => {
    if (adim.tip === 'randevu') {
      return {
        ...adim,
        otp: {
          ...(adim.otp || {}),
          garantiDahilinde: islemTipi === 'Kurulum' ? true : garanti,
        },
      };
    }
    if (adim.tip === 'siparis') {
      if (islemTipi === 'Sipariş') {
        if (garanti) {
          return { ...adim, garantiDahilinde: true, konsinye: false };
        }
        return { ...adim, garantiDahilinde: false, konsinye: adim.konsinye === true };
      }
      return { ...adim, garantiDahilinde: garanti };
    }
    return adim;
  });
}

export function inferSablonGaranti(sablon) {
  if (typeof sablon?.garantiDahilinde === 'boolean') return sablon.garantiDahilinde;
  if (sablon?.islemTipi === 'Kurulum') return true;
  for (const adim of sablon?.adimlar || []) {
    if (adim.tip === 'randevu') return adim.otp?.garantiDahilinde !== false;
    if (adim.tip === 'siparis') return adim.garantiDahilinde !== false;
  }
  return true;
}

export function emptySablon() {
  const islemTipi = 'Sipariş';
  const garantiDahilinde = false;
  return {
    ad: 'Yeni test şablonu',
    aktif: true,
    garantiDahilinde,
    islemTipi,
    musteri: { mod: 'sabit', adi: 'Hilmi', soyadi: 'AKARSU' },
    teknikServisKullaniciAdi: 'ateknik',
    teknisyenKullaniciAdi: 'ateknisyen',
    adminKullaniciAdi: 'admin',
    konum: { latitude: 41.0082, longitude: 28.9784 },
    servisKaydi: {
      urunMod: 'random',
      icerikId: null,
      seriNoMod: 'random',
      seriNo: '',
      checklistMod: 'tumu_evet',
      cihazMod: 'random',
      cihazId: null,
      adresMod: 'varsayilan',
      arizaMod: 'random',
      arizaIds: [],
      arizaAdet: 1,
    },
    adimlar: applySablonGarantiToAdimlar(
      [emptySiparisAdim({ garantiDahilinde: false, konsinye: false, standalone: true })],
      garantiDahilinde,
      islemTipi,
    ),
  };
}

/** Hemen önceki adım sipariş ise parçalar sipariş satırından devralınır */
export function randevuInheritsParcaFromSiparis(adimlar, randevuAdimIndex) {
  if (!adimlar?.length || randevuAdimIndex <= 0) return false;
  return adimlar[randevuAdimIndex - 1]?.tip === 'siparis';
}

/** Son adımda yeni randevu gerekli değilse daha randevu eklenemez */
export function canAddRandevu(adimlar, islemTipi) {
  if (islemTipi === 'Sipariş') return false;
  if (!adimlar?.length) return true;
  for (let i = adimlar.length - 1; i >= 0; i--) {
    if (adimlar[i].tip === 'randevu') {
      return adimlar[i].otp?.yeniRandevuGerekli === true;
    }
  }
  return true;
}

/** Sipariş: önceki randevuda siparisGerekli olmalı (Sipariş tipinde serbest) */
export function canAddSiparis(adimlar, islemTipi) {
  if (islemTipi === 'Sipariş') return true;
  for (let i = adimlar.length - 1; i >= 0; i--) {
    if (adimlar[i].tip === 'randevu') {
      return adimlar[i].otp?.yeniRandevuGerekli && adimlar[i].otp?.siparisGerekli;
    }
    if (adimlar[i].tip === 'siparis') return false;
  }
  return false;
}

export const musteriSelectValue = (m) =>
  m?.adi && m?.soyadi ? `${m.adi}\u0001${m.soyadi}` : '';

export const parseMusteriSelectValue = (value) => {
  if (!value) return { adi: '', soyadi: '' };
  const [adi, soyadi] = value.split('\u0001');
  return { adi: adi || '', soyadi: soyadi || '' };
};

/** @deprecated use emptySablon */
export function emptyArizaSablon() {
  return emptySablon();
}
